import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { smallScreen } from '../../../../common/mixins';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

const rules = ({
  theme,
  hidden,
  isPlayingAds,
  isMobile,
}) => ({
  backgroundImage: `linear-gradient(to bottom, transparent, ${theme.color.overlayDarkHeavy})`,
  bottom: '0',
  justifyContent: 'center',
  left: '0',
  padding: `0 ${theme.margin.small} ${theme.margin.xlarge}`,
  position: 'absolute',
  right: '0',
  transformOrigin: 'bottom',
  transition: 'opacity 150ms, transform 300ms, margin 300ms linear',
  userSelect: 'none',
  zIndex: 1,
  maxWidth: '100%',

  extend: [
    smallScreen({
      padding: `0 0 ${theme.margin.large}`,
    }),
    {
      condition: hidden && !isPlayingAds,
      style: {
        transform: 'translateY(100%)',
        opacity: '0',
      },
    },
    {
      condition: hidden && isPlayingAds,
      style: {
        transform: 'translateY(72px)',
      },
    },
    {
      condition: isMobile,
      style: {
        position: 'fixed', // fix ios address bar and android menu bar at bottom covering player controls
      },
    },
  ],
});

const ControlBarContainer = React.forwardRef((
  { children, hidden, isPlayingAds, onMouseEnter, onMouseLeave, onTouchStart, onTouchEnd }, ref,
) => {
  const { css } = useFela({
    hidden,
    isPlayingAds,
    smallScreen,
    isMobile: [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os),
  });

  return (
    <div
      ref={ref}
      className={css(rules)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {children}
    </div>
  );
});

ControlBarContainer.propTypes = {
  children: PropTypes.node,
  hidden: PropTypes.bool,
  isPlayingAds: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
};

export default React.memo(ControlBarContainer);
